import { render, staticRenderFns } from "./AMRelic80.vue?vue&type=template&id=07f9a95e&scoped=true"
import script from "./AMRelic80.vue?vue&type=script&lang=ts"
export * from "./AMRelic80.vue?vue&type=script&lang=ts"
import style0 from "./AMRelic80.vue?vue&type=style&index=0&id=07f9a95e&prod&lang=scss&scoped=true"
import style1 from "./AMRelic80.vue?vue&type=style&index=1&id=07f9a95e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9a95e",
  null
  
)

export default component.exports